import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.split(/\s+/).map(part => part.charAt(0).toUpperCase()).join('');
}
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-ivory py-10 sm:py-12" aria-labelledby="testimonials-heading" data-id="element-188" data-mp="1my7pb20877u0">
      <div className="mx-auto max-w-5xl px-6" data-id="element-189" data-mp="1d1uolk69jtpr">
        <div className="mx-auto max-w-2xl text-center" data-id="element-190" data-mp="1d135h8turogd">
          <p className="eyebrow text-lime-ink" data-id="element-191" data-mp="1i0o41i541usk">⭐ Verified coaches</p>
          <h2 id="testimonials-heading" className="mt-4 font-display text-[1.85rem] font-extrabold leading-[1.1] text-ink sm:text-4xl" data-id="element-192" data-mp="1hyuvfxaxt0hx">
            What elite coaches are saying
          </h2>
        </div>

        <ul className="mt-9 grid gap-5 md:grid-cols-2" data-id="element-193" data-mp="184l14a2fps4k">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-line bg-shell p-7 shadow-soft" data-id="element-194" data-mp="2yd34cp2sbbb3">
              <div className="flex gap-1" aria-label="Rated 5 out of 5" data-id="element-195" data-mp="2v1b10yehtyp0">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-lime text-lime" aria-hidden="true" data-id="element-196" data-mp="2q1ydscjpmplw" data-mpi={index} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[0.95rem] leading-relaxed text-ink/85" data-id="element-197" data-mp="34tgp3x1mjvyx">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-6" data-id="element-198" data-mp="2c3rr7sk7oc1j">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy-light font-display text-xs font-bold text-navy" aria-hidden="true" data-id="element-199" data-mp="2745a3819ibng">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-200" data-mp="2h08eylni0oe3">
                  <span className="block font-semibold text-ink" data-id="element-201" data-mp="1a5lx6govr5t">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-stone" data-id="element-202" data-mp="3sg6qqxa29oj0">
                    {testimonial.role} · {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}